module.exports = __webpack_public_path__ + "static/noise-58d133e1d1ad5aed0245842bb51ce1b9.png";